"use client";

import AutoBreadcrumbsFrame from "./AutoBreadcrumbsFrame";
import { resolveTrailWith } from "@/lib/breadcrumbs-base";
import { resolveHindiTrail } from "@/lib/breadcrumbs-hi";

/** The /hi/ trail; AutoBreadcrumbs loads this module only on Hindi pages. */
export default function HindiAutoBreadcrumbs({ pathname }: { pathname: string }) {
  const trail = resolveTrailWith(pathname, resolveHindiTrail);
  return trail ? <AutoBreadcrumbsFrame trail={trail} /> : null;
}
